import { Div, Span } from "@tblabs/truffle";
import { appendable } from "@tblabs/truffle/Core/appendable";
import { Box } from "./Utils/Box";


export class ConnectingLineV0 extends Div
{
    constructor(topLabel?: string, bottomLabel?: string)
    {
        super("connecting-line-wrapper");

        this.Append(
            topLabel && new Span(topLabel).Class("line-label line-label-top"),
            new Div().Class("connecting-line"),
            bottomLabel && new Span(bottomLabel).Class("line-label line-label-bottom")
        );
    }
}

export class ConnectingLine extends Div
{
    constructor(top: appendable)
    {
        super("connecting-line-wrapper");

        this.Append(
            top && new Box(top).Class("line-label line-label-top"),
            new Div().Class("connecting-line"),
        );
    }
}
